import { useEffect, useState } from "react";
import { myAxios } from "src/components/common/functions";
import { useMyStore } from "src/components/main/mainStore";
import WorkLogForm from "../workLogForm"
//---------------------------------------------------
export default function EquipmentDamageReport({
    ...rest
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const [truckNumbers, setTruckNumbers] = useState([]);
    useEffect(() => {
        let isMounted = true;
        const getData = async() => {
            //---------------------------------------------------
            setShowLoader(true);
            const res = await myAxios("common/readTruckNumbers.php");
            if(!isMounted) return;
            setShowLoader(false);
            if(!res) return;
            //---------------------------------------------------
            setTruckNumbers(res.data.map(d => d.truckNumber));
        }
        getData();
        return () => {
            isMounted = false;
        }
    }, [])
    //--------------------------------------------------------------------------------------------
    const items = [
        {title: "Department & Lead on Site", type: "text", required: true}, 
        {title: "Truck Number", type: "select", options: truckNumbers, required: false}, 
        {title: "Equipment Affected", type: "text", required: true}, 
        {title: "How was this equipment damaged?", type: "textarea", required: true}, 
        {title: "Was management notified of the damage?", type: "radio", onNoText: "Call your Foreman, Project Coordinator, or Project Manager", required: true}, 
        {title: "Were you able to complete the job despite the damage? (explain on No)", type: "radio", onNo: "textarea", required: true}, 
        {title: "Will this need to be replaced/fixed?", type: "radio", onNoText: "Let your Project Coordinator know", required: true}, 
    ];
    //--------------------------------------------------------------------------------------------
    return(
        <WorkLogForm
            sendEmail
            correctiveActionNeed = {true}
            picsLimit = {0}
            items = {items}
            {...rest}
        />
    )    
}